import { render, staticRenderFns } from "./driver-detail-actions-edit-profile.vue?vue&type=template&id=2e56c731&scoped=true"
import script from "./driver-detail-actions-edit-profile.vue?vue&type=script&lang=js"
export * from "./driver-detail-actions-edit-profile.vue?vue&type=script&lang=js"
import style0 from "./driver-detail-actions-edit-profile.vue?vue&type=style&index=0&id=2e56c731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e56c731",
  null
  
)

export default component.exports